module.exports = __webpack_public_path__ + "static/new-checkout-bb312113d2e3a69fe400d79586ae9600.png";